import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as moment from "moment-timezone";
//import lib
// import { capitalize } from "../../lib/string";

import { saveAs } from "file-saver";
import * as XLSX from 'xlsx';

export const orderPDF = (data: any) => {
    try {
        let resultArr: any[] = [];
        data.map((item: any) => {
            resultArr.push([
                moment(item.orderDate).format("MMM DD,YYYY,h:mm A"),
                item._id,
                item.userCode,
                item.firstCurrency,
                item.secondCurrency,
                item.orderType,
                item.buyorsell,
                item && item.execPrice ? parseFloat(item.execPrice).toFixed(8) : '0',
                (item && item.flag == true) ? 'Market' : item.price,
                item.filledQuantity,
                item.orderType == 'market' && item.buyorsell == 'buy'
                    ? parseFloat(item.filledQuantity).toFixed(8)
                    : parseFloat(item.openQuantity).toFixed(8),
                item.averagePrice,
                item.status,
            ]);
        });
        const unit = "pt";
        const size = "A4"; // Use A1, A2, A3 or A4
        const orientation = "landscape"; // portrait or landscape

        const marginLeft = 40;
        const doc = new jsPDF(orientation, unit, size);

        doc.setFontSize(10);

        const title = "Spot Order Report";
        const headers = [
            [
                "Date",
                "Reference Id",
                "User Id",
                "Base Currency",
                "Quote Currency",
                "Type",
                "Side",
                "Executed price",
                "Price",
                "Filled Amount",
                "Amount",
                "Total",
                "Status"
            ],
        ];

        let content = {
            startY: 50,
            head: headers,
            body: resultArr,
        };
        doc.text(title, marginLeft, 40);
        autoTable(doc, { html: '#my-table' })

        autoTable(doc, content)

        doc.save('Spot Order Report.pdf')
    } catch (err) {
        console.log(err, "-------72");
    }
};

export const orderCSV = (data: any) => {
    try {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Spot Order Report.csv");
        document.body.appendChild(link);
        link.click();
    } catch (err) {

    }
};


export const orderXLS = (rows: any[][], headers: string[]) => {
  try {
    const aoa = [headers];

    for (const row of rows) {
      const newRow = [...row];
      const rawDate = row[1];

     
      const formattedDate = moment.utc(rawDate).tz('Asia/Kolkata').format("MMM DD, YYYY, h:mm:ss A");

      newRow[1] = formattedDate; 

      aoa.push(newRow);
    }

    const worksheet = XLSX.utils.aoa_to_sheet(aoa);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Spot Order Report");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, "Spot Order Report.xlsx");
  } catch (err) {
    console.error("Excel XLS export error", err);
  }
};


export const downloadFile = (data: any) => {
    try {
        const header = [
            "User Id",
            "Coin Name",
            "Total Buy Value",
            "Total Sell Value",
            "Open Orders",
            "Pending Orders",
            "Complete Orders Value",
            "Available Balance",
          ];

        // Add headers as the first row of the data
        const dataWithHeader = [header, ...data.map((item:any) => [
            item.userId,
            item.coinName,
            item.totalBuyValue,
            item.totalSellValue,
            item.openOrders,
            item.pendingOrders,
            item.completeOrdersValue,
            item.availableBalance,
        ])];

        const worksheet = XLSX.utils.aoa_to_sheet(dataWithHeader); // Convert array of arrays to sheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const fileData = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(fileData, "USER_COMPLETE_DETAILS.xlsx");
    } catch (err) {
        console.log(err, "err");
    }
};


